import React from 'react';
import PropTypes from 'prop-types';
import {inject, observer} from 'mobx-react';
import autobind from 'autobind-decorator';

import {Select} from 'spa/Components/Form';
import {withI18n} from 'spa/Components/Context';

const SEARCH = {};

@inject(({store: {cities}}) => ({cities}))
@observer
@withI18n
class CitySelect extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    defaultValue: PropTypes.any,
    cities: PropTypes.shape({
      maybeLoadSearch: PropTypes.func.isRequired,
      getSearch: PropTypes.func.isRequired,
    }).isRequired,
  };

  static defaultProps = {
    className: 'form-control',
  };

  UNSAFE_componentWillMount() {
    this.props.cities.maybeLoadSearch(SEARCH);
  }

  @autobind wrappedInstanceRef(wrappedInstance) {
    this.wrappedInstance = wrappedInstance;
  }

  render() {
    const {cities, className, ...rest} = this.props;
    const {i18n} = this.context;

    const search = cities.getSearch(SEARCH);

    const {isLoading, error, instances} = search;

    let options = [];
    if (isLoading) {
      options.push({
        label: i18n.__('Loading'),
        value: '',
        disabled: true,
      });
    } else if (instances) {
      const visibleCities = instances.filter(city => city.visible);

      options = visibleCities.map(city => ({
        value: city.id,
        label: city.name,
      }));
    }

    return (
      <Select
        data-qa="city-select"
        defaultValue={this.props.defaultValue}
        ref={this.wrappedInstanceRef}
        options={options}
        className={`${className} form-select-trigger`}
        {...rest}
      />
    );
  }
}

export default CitySelect;



// WEBPACK FOOTER //
// ./spa/Components/CitySelect.jsx